import ApiService from "../../../services/api.service";

const RestaurantGroupService = {

	createGroup(data) {
		return ApiService.post(`/restaurantGroup/create`, data)
	},
	updateGroup(id, data) {
		return ApiService.put(`/restaurantGroup/update/${id}`, data)
	},
	listGroup(search) {
		return ApiService.post(`/restaurantGroup/listSearch?search=${search}`, {page: 1, limit: 1000})
	},
	getListForPos() {
		return ApiService.get(`/restaurantGroup/list`)
	},
	activeOrInactive(item) {
		return ApiService.delete(`/restaurantGroup/delete/${item.id}?status=${item.status}`)
	},
	setImageGroup(id, form) {
		return ApiService.post(`/restaurantGroup/addPhotoRestaurantGroup/${id}`, form)
	},
	deletePhotoGroup(groupId, photoId) {
		return ApiService.get(`/restaurantGroup/${groupId}/remove-group-photo/${photoId}`)
	}

}

export default RestaurantGroupService
